import React, { useState, useEffect, useRef, useContext } from "react";
import { ThemeContext } from "../../../../context/ThemeContext";
import { getData, postData, serverURL } from "../../../../services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const HideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ShowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const BannerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);

const LinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// ADD WEB BANNER DIALOG (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const AddWebBannerDialog = ({ onClose, onSave, editingBanner, theme }) => {
  const [formData, setFormData] = useState({
    title: editingBanner?.title || "",
    title2: editingBanner?.title2 || "",
    description: editingBanner?.description || "",
    buttonname: editingBanner?.buttonname || "",
    buttonlink: editingBanner?.buttonlink || "",
    hide: editingBanner?.hide === 0 ? "Show" : "Hide",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(editingBanner?.pic ? getImageUrl(editingBanner.pic) : null);
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  function getImageUrl(picName) {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") {
      return null;
    }
    let filename = picName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    return `${serverURL}/public/uploadnew/upload/${filename}`;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => {
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    handleImageChange(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleImageChange(file);
    }
  };

  const uploadImage = async (file) => {
    if (!file) return null;
    
    const formDataImg = new FormData();
    formDataImg.append("image", file);
    
    try {
      const response = await postData("upload/webbanner", formDataImg, "multipart/form-data");
      if (response && response.status === true && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Image upload error:", error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      alert("Please enter banner title");
      return;
    }
    
    setUploading(true);
    
    let uploadedImagePath = editingBanner?.pic || null;
    
    if (imageFile) {
      const uploadedPath = await uploadImage(imageFile);
      if (uploadedPath) {
        uploadedImagePath = uploadedPath;
      }
    }
    
    const bannerData = {
      title: formData.title,
      title2: formData.title2 || "",
      description: formData.description || "",
      buttonname: formData.buttonname || "",
      buttonlink: formData.buttonlink || "",
      hide: formData.hide === "Hide" ? 1 : 0,
      pic: uploadedImagePath,
    };
    
    onSave(bannerData, editingBanner);
    setUploading(false);
    onClose();
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    background: theme.surfaceLighter,
    border: `1px solid ${theme.border}`,
    borderRadius: "12px",
    fontSize: "14px",
    color: theme.textPrimary,
    outline: "none",
    transition: "all 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "12px",
    fontWeight: 600,
    color: theme.textSecondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(8px)",
        animation: "fadeIn 0.2s ease-out",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "600px",
          background: theme.surface,
          borderRadius: "20px",
          boxShadow: `0 25px 60px ${theme.primary}30`,
          overflow: "hidden",
          animation: "slideUp 0.3s ease-out",
          border: `1px solid ${theme.border}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "18px 24px",
            borderBottom: `1px solid ${theme.border}`,
            background: theme.surfaceLighter,
          }}
        >
          <h3 style={{ fontSize: "20px", fontWeight: 700, color: theme.textPrimary, margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
            {editingBanner ? <EditIcon /> : <PlusIcon />}
            {editingBanner ? "Edit Web Banner" : "Add Web Banner"}
          </h3>
          <button
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: theme.textMuted,
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              transition: "all 0.2s",
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = `${theme.error || theme.danger}15`;
              e.currentTarget.style.color = theme.error || theme.danger;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
              e.currentTarget.style.color = theme.textMuted;
            }}
          >
            <CloseIcon />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ padding: "24px", maxHeight: "65vh", overflowY: "auto" }}>
            {/* Title */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>
                Title <span style={{ color: theme.error || theme.danger }}>*</span>
              </label>
              <input
                type="text"
                name="title"
                style={inputStyle}
                placeholder="Enter banner title"
                value={formData.title}
                onChange={handleChange}
                required
                autoFocus
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Subtitle */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Subtitle (Title 2)</label>
              <input
                type="text"
                name="title2"
                style={inputStyle}
                placeholder="Enter banner subtitle"
                value={formData.title2}
                onChange={handleChange}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Description */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Description</label>
              <textarea
                name="description"
                style={{ ...inputStyle, minHeight: "80px", resize: "vertical" }}
                placeholder="Enter banner description"
                value={formData.description}
                onChange={handleChange}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Image Upload */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Image</label>
              <div
                style={{
                  border: `2px dashed ${dragActive ? theme.primary : theme.border}`,
                  borderRadius: "16px",
                  padding: "24px",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  background: dragActive ? `${theme.primary}08` : theme.surfaceLighter,
                  marginTop: "8px",
                }}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/webp"
                  onChange={handleFileInput}
                  style={{ display: "none" }}
                />
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px", color: theme.primary }}>
                  <UploadIcon />
                </div>
                <div style={{ fontSize: "14px", fontWeight: 600, color: theme.textPrimary, marginBottom: "6px" }}>
                  {imagePreview ? "Change Image" : "Click or drag image here"}
                </div>
                <div style={{ fontSize: "11px", color: theme.textMuted }}>
                  PNG, JPG, WebP up to 10MB
                </div>
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      width: "100%",
                      maxHeight: "160px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      marginTop: "16px",
                      border: `1px solid ${theme.border}`,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Button Name & Link */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "20px" }}>
              <div>
                <label style={labelStyle}>Button Name</label>
                <input
                  type="text"
                  name="buttonname"
                  style={inputStyle}
                  placeholder="e.g., Order Now"
                  value={formData.buttonname}
                  onChange={handleChange}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = theme.primary;
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = theme.border;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
              <div>
                <label style={labelStyle}>Button Link</label>
                <input
                  type="text"
                  name="buttonlink"
                  style={inputStyle}
                  placeholder="e.g., /order"
                  value={formData.buttonlink}
                  onChange={handleChange}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = theme.primary;
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = theme.border;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>

            {/* Visibility */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Visibility</label>
              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                <label
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: theme.textPrimary,
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.hide === "Show" ? theme.success : theme.border}`,
                    background: formData.hide === "Show" ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s",
                  }}
                >
                  <input
                    type="radio"
                    name="hide"
                    value="Show"
                    checked={formData.hide === "Show"}
                    onChange={handleChange}
                    style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: theme.success }}
                  />
                  <ShowIcon /> Show
                </label>
                <label
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: theme.textPrimary,
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: `1px solid ${formData.hide === "Hide" ? theme.textMuted : theme.border}`,
                    background: formData.hide === "Hide" ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s",
                  }}
                >
                  <input
                    type="radio"
                    name="hide"
                    value="Hide"
                    checked={formData.hide === "Hide"}
                    onChange={handleChange}
                    style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: theme.textMuted }}
                  />
                  <HideIcon /> Hide
                </label>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}
          >
            <button
              type="button"
              style={{
                padding: "10px 20px",
                background: "transparent",
                border: `1px solid ${theme.border}`,
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: 500,
                color: theme.textPrimary,
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onClick={onClose}
              onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surface)}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: "10px 24px",
                background: uploading ? theme.textMuted : theme.primary,
                border: "none",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: 600,
                color: "#fff",
                cursor: uploading ? "not-allowed" : "pointer",
                boxShadow: uploading ? "none" : `0 4px 12px ${theme.primary}40`,
                transition: "all 0.2s ease",
              }}
              disabled={uploading}
              onMouseEnter={(e) => {
                if (!uploading) {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = uploading ? "none" : `0 4px 12px ${theme.primary}40`;
              }}
            >
              {uploading ? "⏳ Uploading..." : (editingBanner ? "Update Banner" : "Save Banner")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ hide, theme }) => {
  const isVisible = hide === 0;
  const config = isVisible
    ? { bg: `${theme.success}1a`, color: theme.success, text: "Visible", dot: theme.success }
    : { bg: `${theme.textMuted}1a`, color: theme.textMuted, text: "Hidden", dot: theme.textMuted };
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        padding: "4px 10px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 600,
        background: config.bg,
        color: config.color,
      }}
    >
      <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: config.dot }} />
      {config.text}
    </span>
  );
};

const ImagePlaceholder = ({ imageUrl, title, theme }) => {
  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") return null;
    let filename = picName;
    if (filename.includes('/')) filename = filename.split('/').pop();
    return `${serverURL}/public/uploadnew/upload/${filename}`;
  };
  
  const imgUrl = imageUrl ? getImageUrl(imageUrl) : null;
  
  return (
    <div
      style={{
        width: "48px",
        height: "48px",
        borderRadius: "10px",
        background: `${theme.primary}15`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        border: `1px solid ${theme.border}`,
        overflow: "hidden",
        color: theme.primary,
        flexShrink: 0,
      }}
    >
      {imgUrl ? (
        <img src={imgUrl} alt={title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <BannerIcon />
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const WebBanners = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const itemsPerPage = 10;

  // Fetch banners
  const fetchBanners = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData("footercertificate/webbanner");
      console.log("API Response:", response);
      
      let bannersData = [];
      if (response && response.status === true && response.data) {
        bannersData = response.data;
      } else if (Array.isArray(response)) {
        bannersData = response;
      } else if (response?.data && Array.isArray(response.data)) {
        bannersData = response.data;
      }
      
      setBanners(bannersData);
    } catch (err) {
      console.error("Error fetching banners:", err);
      setError(err.message || "Failed to fetch banners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // Filter banners
  const filteredBanners = banners.filter(banner =>
    banner.title?.toLowerCase().includes(search.toLowerCase()) ||
    (banner.title2 && banner.title2.toLowerCase().includes(search.toLowerCase())) ||
    (banner.description && banner.description.toLowerCase().includes(search.toLowerCase()))
  );

  // Pagination
  const totalPages = Math.ceil(filteredBanners.length / itemsPerPage);
  const paginatedBanners = filteredBanners.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Toggle status
  const toggleStatus = async (banner) => {
    const newHideValue = banner.hide === 0 ? 1 : 0;
    setActionLoading(true);
    try {
      const response = await postData("footercertificate/update_webbanner", {
        id: banner.id,
        hide: newHideValue
      });
      if (response && response.status === true) {
        fetchBanners();
      } else {
        alert(response?.message || "Failed to update status");
      }
    } catch (error) {
      alert("Failed to update status: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    setActionLoading(true);
    try {
      const response = await postData("footercertificate/delete_webbanner", { id });
      if (response && response.status === true) {
        fetchBanners();
      } else {
        alert(response?.message || "Failed to delete banner");
      }
    } catch (error) {
      alert("Failed to delete banner: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
    setIsDialogOpen(true);
  };

  const handleView = (banner) => {
    alert(`📋 Banner Details\n\nTitle: ${banner.title}\nSubtitle: ${banner.title2 || "—"}\nDescription: ${banner.description || "—"}\nButton: ${banner.buttonname || "—"}\nLink: ${banner.buttonlink || "—"}`);
  };

  const handleAddBanner = () => {
    setEditingBanner(null);
    setIsDialogOpen(true);
  };

  const handleSaveBanner = async (bannerData, existingBanner) => {
    setActionLoading(true);
    try {
      let response;
      if (existingBanner) {
        response = await postData("footercertificate/update_webbanner", {
          id: existingBanner.id,
          title: bannerData.title,
          title2: bannerData.title2,
          description: bannerData.description,
          buttonname: bannerData.buttonname,
          buttonlink: bannerData.buttonlink,
          hide: bannerData.hide,
          pic: bannerData.pic,
        });
      } else {
        response = await postData("footercertificate/create_webbanner", bannerData);
      }
      
      if (response && response.status === true) {
        fetchBanners();
        alert(existingBanner ? "Banner updated successfully" : "Banner added successfully");
      } else {
        alert(response?.message || "Failed to save banner");
      }
    } catch (error) {
      alert("Failed to save banner: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const styles = {
    container: {
      background: "transparent",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      padding: "20px 24px",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
      flexWrap: "wrap",
      gap: "16px",
    },
    searchWrapper: {
      position: "relative",
      flex: 1,
      maxWidth: "400px",
      minWidth: "250px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 38px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      outline: "none",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
    },
    addBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 20px",
      background: theme.primary,
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: `0 4px 12px ${theme.primary}40`,
      transition: "all 0.2s ease",
    },
    refreshBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 16px",
      background: theme.surfaceLighter,
      color: theme.textSecondary,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    tableWrapper: {
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: `0 4px 12px ${theme.primary}08`,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "1000px",
    },
    th: {
      padding: "14px 16px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 700,
      color: theme.primary,
      borderBottom: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      whiteSpace: "nowrap",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    td: {
      padding: "14px 16px",
      fontSize: "13px",
      color: theme.textPrimary,
      borderBottom: `1px solid ${theme.border}`,
    },
    actions: {
      display: "flex",
      gap: "6px",
    },
    titleCell: {
      fontWeight: 600,
      color: theme.textPrimary,
      maxWidth: "180px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    subtitleCell: {
      maxWidth: "180px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.textSecondary,
    },
    buttonBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "4px 10px",
      borderRadius: "8px",
      fontSize: "11px",
      fontWeight: 600,
      background: `${theme.primary}1a`,
      color: theme.primary,
    },
    pagination: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "14px 20px",
      borderTop: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      flexWrap: "wrap",
      gap: "12px",
    },
    emptyState: {
      padding: "60px",
      textAlign: "center",
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
      
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.searchWrapper}>
          <span
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: theme.primary,
              display: "flex",
              alignItems: "center",
            }}
          >
            <SearchIcon />
          </span>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search banners by title, subtitle or description..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = theme.primary;
              e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = theme.border;
              e.currentTarget.style.boxShadow = "none";
            }}
          />
          {search && (
            <button
              onClick={() => { setSearch(""); setCurrentPage(1); }}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: theme.textMuted,
                padding: "4px",
                display: "flex",
              }}
            >
              <XIcon />
            </button>
          )}
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            style={styles.refreshBtn}
            onClick={fetchBanners}
            disabled={loading}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = theme.surfaceHover || theme.surface;
              e.currentTarget.style.color = theme.primary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme.surfaceLighter;
              e.currentTarget.style.color = theme.textSecondary;
            }}
          >
            <RefreshIcon /> Refresh
          </button>
          <button
            style={styles.addBtn}
            onClick={handleAddBanner}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
            }}
          >
            <PlusIcon /> Add Banner
          </button>
        </div>
      </div>

      {/* Table */}
      <div style={styles.tableWrapper}>
        <div style={{ overflowX: "auto" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>Image</th>
                <th style={styles.th}>Title</th>
                <th style={styles.th}>Subtitle</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}>Button</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8}>
                    <div style={{ padding: "60px", textAlign: "center" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          border: `3px solid ${theme.border}`,
                          borderTopColor: theme.primary,
                          borderRadius: "50%",
                          margin: "0 auto 16px",
                          animation: "spin 0.8s linear infinite",
                        }}
                      />
                      <p style={{ color: theme.textMuted, fontSize: "14px", margin: 0 }}>
                        Loading banners...
                      </p>
                    </div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan={8}>
                    <div style={{ padding: "60px", textAlign: "center" }}>
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          background: `${theme.error || theme.danger}15`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                          color: theme.error || theme.danger,
                          fontSize: "24px",
                        }}
                      >
                        ⚠️
                      </div>
                      <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px" }}>
                        Error Loading Banners
                      </h3>
                      <p style={{ color: theme.textMuted, fontSize: "13px", marginBottom: "16px" }}>
                        {error}
                      </p>
                      <button
                        onClick={fetchBanners}
                        style={{
                          padding: "8px 20px",
                          borderRadius: "8px",
                          border: "none",
                          background: theme.primary,
                          color: "#fff",
                          cursor: "pointer",
                          fontWeight: 600,
                        }}
                      >
                        Retry
                      </button>
                    </div>
                  </td>
                </tr>
              ) : paginatedBanners.length === 0 ? (
                <tr>
                  <td colSpan={8}>
                    <div style={styles.emptyState}>
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          background: `${theme.primary}15`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                          color: theme.primary,
                        }}
                      >
                        <BannerIcon />
                      </div>
                      <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px", fontWeight: 600 }}>
                        {search ? "No Matching Banners" : "No Banners Found"}
                      </h3>
                      <p style={{ color: theme.textMuted, fontSize: "13px", margin: 0 }}>
                        {search ? "Try a different search term" : "Create your first banner to get started"}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                paginatedBanners.map((banner) => (
                  <tr
                    key={banner.id}
                    style={{ transition: "background 0.15s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surfaceLighter)}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    <td style={{ ...styles.td, color: theme.primary, fontFamily: "monospace", fontWeight: 700 }}>
                      #{banner.id}
                    </td>
                    <td style={styles.td}>
                      <ImagePlaceholder imageUrl={banner.pic} title={banner.title} theme={theme} />
                    </td>
                    <td style={{ ...styles.td, ...styles.titleCell }} title={banner.title}>
                      {banner.title}
                    </td>
                    <td style={{ ...styles.td, ...styles.subtitleCell }} title={banner.title2}>
                      {banner.title2 || "—"}
                    </td>
                    <td style={{ ...styles.td, ...styles.subtitleCell }} title={banner.description}>
                      {banner.description || "—"}
                    </td>
                    <td style={styles.td}>
                      {banner.buttonname ? (
                        <div>
                          <span style={styles.buttonBadge}>{banner.buttonname}</span>
                          {banner.buttonlink && (
                            <div
                              style={{
                                fontSize: "10px",
                                color: theme.textMuted,
                                marginTop: "4px",
                                fontFamily: "monospace",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <LinkIcon /> {banner.buttonlink}
                            </div>
                          )}
                        </div>
                      ) : "—"}
                    </td>
                    <td style={styles.td}>
                      <StatusBadge hide={banner.hide} theme={theme} />
                    </td>
                    <td style={styles.td}>
                      <div style={styles.actions}>
                        <button
                          style={{
                            background: `${theme.primary}15`,
                            border: `1px solid ${theme.primary}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: theme.primary,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => handleView(banner)}
                          title="View"
                          disabled={actionLoading}
                          onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.primary}25`)}
                          onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.primary}15`)}
                        >
                          <EyeIcon />
                        </button>
                        <button
                          style={{
                            background: `${theme.warning}15`,
                            border: `1px solid ${theme.warning}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: theme.warning,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => handleEdit(banner)}
                          title="Edit"
                          disabled={actionLoading}
                          onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.warning}25`)}
                          onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.warning}15`)}
                        >
                          <EditIcon />
                        </button>
                        <button
                          style={{
                            background: banner.hide === 0 ? `${theme.success}15` : `${theme.textMuted}15`,
                            border: `1px solid ${banner.hide === 0 ? theme.success : theme.textMuted}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: banner.hide === 0 ? theme.success : theme.textMuted,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => toggleStatus(banner)}
                          title={banner.hide === 0 ? "Hide" : "Show"}
                          disabled={actionLoading}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = banner.hide === 0 ? `${theme.success}25` : `${theme.textMuted}25`;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = banner.hide === 0 ? `${theme.success}15` : `${theme.textMuted}15`;
                          }}
                        >
                          {banner.hide === 0 ? <HideIcon /> : <ShowIcon />}
                        </button>
                        <button
                          style={{
                            background: `${theme.error || theme.danger}15`,
                            border: `1px solid ${theme.error || theme.danger}30`,
                            cursor: actionLoading ? "not-allowed" : "pointer",
                            padding: "6px 8px",
                            color: theme.error || theme.danger,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                            opacity: actionLoading ? 0.5 : 1,
                          }}
                          onClick={() => handleDelete(banner.id)}
                          title="Delete"
                          disabled={actionLoading}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = theme.error || theme.danger;
                            e.currentTarget.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                            e.currentTarget.style.color = theme.error || theme.danger;
                          }}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {!loading && filteredBanners.length > itemsPerPage && (
          <div style={styles.pagination}>
            <span style={{ fontSize: "12px", color: theme.textSecondary }}>
              Showing <strong style={{ color: theme.textPrimary }}>{Math.min((currentPage - 1) * itemsPerPage + 1, filteredBanners.length)}</strong> to <strong style={{ color: theme.textPrimary }}>{Math.min(currentPage * itemsPerPage, filteredBanners.length)}</strong> of <strong style={{ color: theme.textPrimary }}>{filteredBanners.length}</strong> banners
            </span>
            <div style={{ display: "flex", gap: "6px" }}>
              <button
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  background: theme.surface,
                  color: currentPage === 1 ? theme.textMuted : theme.textPrimary,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: currentPage === 1 ? 0.5 : 1,
                  transition: "all 0.2s ease",
                }}
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
              >
                ‹
              </button>
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNum;
                if (totalPages <= 5) pageNum = i + 1;
                else if (currentPage <= 3) pageNum = i + 1;
                else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
                else pageNum = currentPage - 2 + i;
                return pageNum <= totalPages && (
                  <button
                    key={pageNum}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "6px",
                      border: currentPage === pageNum ? `1px solid ${theme.primary}` : `1px solid ${theme.border}`,
                      background: currentPage === pageNum ? theme.primary : theme.surface,
                      color: currentPage === pageNum ? "#fff" : theme.textSecondary,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: currentPage === pageNum ? 700 : 500,
                      fontSize: "12px",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => setCurrentPage(pageNum)}
                  >
                    {pageNum}
                  </button>
                );
              })}
              <button
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  background: theme.surface,
                  color: currentPage === totalPages ? theme.textMuted : theme.textPrimary,
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  transition: "all 0.2s ease",
                }}
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
              >
                ›
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Dialog */}
      {isDialogOpen && (
        <AddWebBannerDialog
          onClose={() => { setIsDialogOpen(false); setEditingBanner(null); }}
          onSave={handleSaveBanner}
          editingBanner={editingBanner}
          theme={theme}
        />
      )}
    </div>
  );
};

export default WebBanners;